import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Link, useNavigate } from 'react-router-dom';
import { API_URL } from '../constants';
import { useVendor } from '../hooks/provider/VendorProvidor';
import { xorEncrypt } from '../utils/xorCrypto';
import { useTokens } from '../context/TokenContext';

const LoginForm = () => {
    const { getItem, setItem } = useTokens();
    const navigate = useNavigate();
    const { updateVendor } = useVendor();
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        const existingToken = getItem('vendor', 'AuthToken');
        if (existingToken) {
        navigate('/vendor/dashboard');
        }
    }, [getItem, navigate]);

    const handleLogin = async (e) => {
        e.preventDefault();
        setLoading(true);
        const toastId = toast.loading('Logging in...', { autoClose: false });

        try {
            const encPass = xorEncrypt(password);
            const response = await axios.post(`${API_URL}/vendor/login`, {
                email,
                password: encPass,
            });

            if(response.data.temp_token && response.data.user) {
                localStorage.setItem('vendorProfile', JSON.stringify(response.data.user));
                toast.update(toastId, {
                    render: 'Temporary token received. Please complete your profile.',
                    type: 'info',
                    isLoading: false,
                    autoClose: 3000,
                });
                navigate('/vendor/complete-profile');
                return;
            }
            
            const { token, user } = response.data;

            setItem('vendor', 'AuthToken', token);
            setItem('vendor', 'UserInfo', user);

            toast.update(toastId, {
                render: 'Login successful!',
                type: 'success',
                isLoading: false,
                autoClose: 3000,
            });
            navigate('/vendor');
        } catch (err) {
            toast.update(toastId, {
                render: err.response?.data?.message || 'Login failed! Please try again.',
                type: 'error',
                isLoading: false,
                autoClose: 3000,
            });
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <h4 className="text-start fw-bold mb-5" style={{ color: 'hsl(217, 10%, 50.8%)' }}>
                Login Form
            </h4>
            <form onSubmit={handleLogin}>
                <div className="row">
                    <div className="col-md-12">
                        <div className="mb-3">
                            <label htmlFor="email" className="form-label">
                                Email <span className="text-danger">*</span>
                            </label>
                            <input
                                type="email"
                                className="form-control"
                                id="mail"
                                name="email"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                required />
                        </div>
                    </div>
                    <div className="col-md-12">
                        <div className="mb-3">
                            <label htmlFor="password" className="form-label">
                                Password <span className="text-danger">*</span>
                            </label>
                            <div className="input-group">
                                <input
                                    type="password"
                                    className="form-control passwordField"
                                    id="password"
                                    name="password"
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)}
                                    required />
                                <span className="input-group-text">
                                    <i
                                        className="bi bi-eye"
                                        style={{ cursor: 'pointer' }}
                                        onClick={() => {
                                            const passwordField = document.getElementById('password');
                                            passwordField.type = passwordField.type === 'password' ? 'text' : 'password';
                                        }}
                                    ></i>
                                </span>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-12">
                        <button type="submit" className="btn btn-primary w-100" disabled={loading}>
                            {loading ? 'Processing...' : 'Login'}
                        </button>
                    </div>
                    <div className="col-6 text-start py-2">
                        <span>
                            Existing User? <Link to="/vendor/register">Register</Link>
                        </span>
                    </div>
                    <div className="col-6 text-end py-2">
                        <span><Link to="/vendor/reset-password">Forgot Password</Link></span>
                    </div>
                </div>
            </form>
        </>
    );
};

export default LoginForm;
